import {Calendar} from 'antd';
import moment from 'moment';
import React from 'react';
import AvailabilityHeader from './AvailabilityHeader';
import {withAuthorizationV2} from '../../../services/Authorization';
import Constants from '../../../services/Constants';

import './AvailabilityCalendar.css';
import {useIntl} from "react-intl";

const AvailabilityCalendar = ({availabilities, config, error, intervention, onPropagateNavigate, selectedMonth}) => {
  const intl = useIntl();

  const computeCellColor = (availability) => {
    if (!availability) {
      return "calendar-box--expired";
    }
    if (config && config.mobility) {
      if (!isMobilityAvailable(availability.mobility)) {
        return "calendar-box--no-rental";
      }
    }
    if (availability.status === Constants.DAY_OPEN.value) {
      return "calendar-box--available";
    }
    if (availability.status === Constants.DAY_OVERBOOKED.value) {
      return "calendar-box--unavailable";
    }
    return "calendar-box--closed";
  };

  const isMobilityAvailable = (availableMobilities) => {
    const {journey: {properties: {mobility: {mobility}} = {}} = {}} = intervention;
    if (!isVehicle(mobility)) {
      return true; // irrelevant
    }
    return availableMobilities.find(availableMobility => Constants.MOBILITY_VEHICLES.includes(availableMobility) && availableMobility === mobility.name)
  }

  const isVehicle = (requestedMobility) => {
    return (Constants.MOBILITY_VEHICLES.indexOf(requestedMobility.name) >= 0);
  };

  const renderDateFullCell = (date) => {
    const formattedDate = moment(date).format(Constants.DATE_FORMAT_API);
    const availability = availabilities.find(a => a.day === formattedDate);
    const cellColor = computeCellColor(availability);
    return (
      <div className="ant-fullcalendar-date">
        <div className={cellColor + " calendar--rounded-value ant-fullcalendar-value"}>
          <div style={{position: 'relative', top: '30%'}}>
            {moment(date).format("D")}
          </div>
        </div>
      </div>
    );
  };

  const {journey: {properties: {mobility: {mobility}} = {}} = {}} = intervention;
  const displayMobility = isVehicle(mobility);
  const colClassName = displayMobility ? 'col-sm-6 col-lg-4' : 'col-sm-6';

  if (error && error.code) {
    return <div className={"alert alert--error mt-6"}>{intl.formatMessage({id: error.code})}</div>
  }

  if (!availabilities) {
    return null;
  }

  return (
    <div>
      <Calendar
        className="calendar--hidden-year calendar--rounded"
        dateFullCellRender={renderDateFullCell}
        disabledDate={() => true}
        fullscreen={false}
        headerRender={({value, onChange}) => {
          return <AvailabilityHeader onChange={onChange} onPropagateNavigate={onPropagateNavigate} selectedMonth={selectedMonth} value={value}/>
        }}
      />
      <div className="row">
        <div className={colClassName} style={{textAlign: "center"}}>
          <span className="fc-event-dot calendar-legend__color--green"/> {intl.formatMessage({id: 'appointment.planning.available'})}
        </div>
        <div className={colClassName} style={{textAlign: "center"}}>
          <span className="fc-event-dot calendar-legend__color--red"/> {intl.formatMessage({id: 'appointment.planning.unavailable'})}
        </div>
        {displayMobility &&
          <div className={colClassName} style={{textAlign: "center"}}>
            <span className="fc-event-dot calendar-legend__color--orange"/> {intl.formatMessage({id: 'appointment.planning.no-rental-car'})}
          </div>
        }
      </div>
    </div>
  )
}

export default withAuthorizationV2(AvailabilityCalendar, ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']);
